// SignInPage — full-page sign-in gate shown to anyone without a session.
//
// Rendered by App.tsx in place of the Hub/Gamer Zone shell whenever
// useProfile() resolves to no profile (no session cookie, or an expired /
// invalid one). The only action available is the SSO link: a plain
// navigation to GET /auth/login, which the backend redirects from Cognito's
// Hosted UI straight to the Nelnet Entra tenant (see core/cognito_auth.py).
// In dev (SSO_ENABLED=false) this page is never seen in practice — the
// apiClient dev-stub bootstrap (src/lib/api-client.ts) signs the stub user
// in on first load before this would render.
import "./auth.css";
import type { ReactElement } from "react";
import { BrandMark } from "@/features/hub-feed/design-atoms";

export function SignInPage(): ReactElement {
  return (
    <div className="auth-signin-page">
      <div className="auth-signin-card">
        <BrandMark size={56} />
        <h1 className="auth-signin-title">AI Builder Hub</h1>
        <p className="auth-signin-subtitle">
          Sign in with your Nelnet Business Services account to browse and share AI projects,
          skills, and templates.
        </p>
        <a className="btn btn-primary auth-signin-btn" href="/auth/login">
          Sign in with Nelnet SSO
        </a>
        <p className="auth-signin-disclaimer">Unauthorized access is prohibited.</p>
      </div>
    </div>
  );
}
